<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     :style="'background-image: url(/storage/banner/60e3e3b545c85.png);'">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100" ref="form" data-url="/user/confirm" action="store">
                        <div class="text-center mb-4">
                        </div>

                        <div class="col-12">
                            <div class="form-row-lang">
                                <span @click="changeLang('cs')" :class="lang == 'cs' ? 'active' : ''">Čeština</span>
                                <span @click="changeLang('sk')" :class="lang == 'sk' ? 'active' : ''">Slovenčina</span>
                                <span @click="changeLang('en')" :class="lang == 'en' ? 'active' : ''">English</span>
                            </div><br><br>

                        </div>

                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <label for="user_first_name">First name</label>
                                <app-input type="text"
                                           v-model="user.first_name"
                                           placeholder="Enter first name"
                                           :required="true"
                                />
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <label for="user_first_name">Krstné jméno</label>
                                <app-input type="text"
                                           v-model="user.first_name"
                                           placeholder="Zadajte krstné meno"
                                           :required="true"
                                />
                            </div>
                            <div v-else class="form-group col-12">
                                <label for="user_first_name">{{ $t('first_name') }}</label>
                                <app-input type="text"
                                           v-model="user.first_name"
                                           :placeholder="$t('enter_first_name')"
                                           :required="true"
                                />
                            </div>
                        </div>

                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <label for="user_last_name">Last name</label>
                                <app-input type="text"
                                           v-model="user.last_name"
                                           placeholder="Enter last name"
                                           :required="true"
                                />
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <label for="user_last_name">Priezvisko</label>
                                <app-input type="text"
                                           v-model="user.last_name"
                                           placeholder="Zadajte priezvisko"
                                           :required="true"
                                />
                            </div>
                            <div v-else class="form-group col-12">
                                <label for="user_last_name">{{ $t('last_name') }}</label>
                                <app-input type="text"
                                           v-model="user.last_name"
                                           :placeholder="$t('enter_last_name')"
                                           :required="true"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12 mb-3">
                                <label for="user_password">Password</label>
                                <app-input type="password"
                                           v-model="user.password"
                                           :specialValidation="true"
                                           placeholder="Enter your password"
                                           :required="true"
                                           @focus="showPasswordHint()"
                                />
                                <div class="mt-2">
                                    <div class="note note-warning p-4"><p class="m-1">A password should contain one: an uppercase letter, a special character (eg !, #, &amp;) and a number. Min. length 8 characters.</p>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12 mb-3">
                                <label for="user_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="user.password"
                                           :specialValidation="true"
                                           placeholder="Zadajte svoje heslo"
                                           :required="true"
                                           @focus="showPasswordHint()"
                                />
                                <div class="mt-2">
                                    <div class="note note-warning p-4"><p class="m-1">Heslo by malo obsahovať jedno: veľké písmeno, špeciálny znak (napr. !, #, &amp;) a číslo. Min. dĺžka 8 znakov.</p>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="form-group col-12 mb-3">
                                <label for="user_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="user.password"
                                           :specialValidation="true"
                                           :placeholder="$t('enter_your_password')"
                                           :required="true"
                                           @focus="showPasswordHint()"
                                />
                                <div class="mt-2">
                                    <div class="note note-warning p-4"><p class="m-1">Heslo by mělo obsahovat jedno: velké písmeno, speciální znak (např. !, #, &amp;) a číslo. Min. délka 8 znaků.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row second-password" style="display:none;">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <app-input type="password"
                                           same-as="user_password"
                                           v-model="user.password_confirmation"
                                           placeholder="Enter your password again"
                                           :required="true"
                                />

                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <app-input type="password"
                                           same-as="user_password"
                                           v-model="user.password_confirmation"
                                           placeholder="Zadajte svoje heslo znova (pre kontrolu)"
                                           :required="true"
                                />

                            </div>
                            <div v-else class="form-group col-12">
                                <app-input type="password"
                                           same-as="user_password"
                                           v-model="user.password_confirmation"
                                           :placeholder="$t('confirm_password')"
                                           :required="true"
                                />

                            </div>

                        </div>

                        <div class="form-row" v-if="recaptchaEnable == 1">
                            <div class="form-group col-12 px-0">
                                <re-captcha :site-key="siteKey"></re-captcha>
                            </div>
                        </div>
                        <div class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               label="Sign Up"
                                               :class="{'disabled': !userInfo}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               label="Registrovať sa"
                                               :class="{'disabled': !userInfo}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                            <div v-else class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               :label="$t('sign_up_button')"
                                               :class="{'disabled': !userInfo}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') }} Onboardio<br>
                                    <a href="https://onboardio.cz/obchodni-podminky.html" target="_blank" class="text-muted">Obchodní podmínky</a>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import PasswordWarning from './PasswordWarning';
    import {AuthMixin} from "./Mixins/AuthMixin";

    export default {
        name: "Registration",
        mixins: [AuthMixin, ThemeMixin],
        components: {
            PasswordWarning
        },
        props: {
            userInfo: {},
            siteKey: String,
            recaptchaEnable: {},
        },
        data() {
            return {
                userData: {},
                user: {
                    first_name: '',
                    last_name: '',
                },
                lang: 'cs',

            }
        },
        created() {
            if (this.userInfo) {
                this.userData = JSON.parse(this.userInfo);
            }
        },
        mounted() {
            let loginLang = "";
            if(this.getCookie("loginLang")){
                loginLang = this.getCookie("loginLang");
                this.changeLang(loginLang);
            }
        },
        methods: {
            submit() {
                let data = this.user;
                data.email = this.userData.email;
                data.invitation_token = this.userData.invitation_token;
                this.save(data);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                location.replace('/admin/users/login');
            },
            showPasswordHint() {
                $('.second-password').slideDown();
            },
            changeLang(lang){
                this.lang = lang;
                document.cookie = "loginLang="+lang+";path=/";
            },
            getCookie(cname) {
              let name = cname + "=";
              let ca = document.cookie.split(';');
              for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return "";
            }
        }


    }
</script>
